import React, { useState, useRef } from "react";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import GoToTop from "../scroll-icon/GoToTop";
import ScrollToTop from "../scroll-icon/ScrollToTop";
import ChatIcon from "../chat/ChatIcon";
import SeoComponent from "../../../SeoComponent";

const DeliveryPartnershipTC = () => {
  const [openSection, setOpenSection] = useState(null);

  const accordionRefs = {
    ForClients: useRef(null),
    ForCustomers: useRef(null),
    PurchasingProduct: useRef(null),
    Communication: useRef(null),
    Confirmation: useRef(null),
    Acceptance: useRef(null),
    ProcessesRelative: useRef(null),
    Payment: useRef(null),
    GeneralPrinciples: useRef(null),
    Cancellation: useRef(null),
    ReturnOrders: useRef(null),
  };

  const toggleAccordion = (section) => {
    setOpenSection((prevSection) => (prevSection === section ? null : section));

    if (openSection !== section) {
      setTimeout(() => {
        accordionRefs[section].current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 1000);
    }
  };

  const for_clients = [
    "This Delivery Service Agreement (The “Terms”) sets forth relevant terms and conditions governing the provision of Delivery Services for items received via Fusion Kitchen, and your relationship with Fusion Kitchen where you request it to provide Delivery Services as described below. You can contact us by using the Help Section on the Fusion Kitchen page.",
    "In order to request Delivery Services in the UK for the first time, all Fusion Kitchen users must accept these terms and conditions. By requesting Delivery Services, you confirm that you accept these terms. These terms will apply to all subsequent orders you receive for Delivery Services.",
    "When accessing or using the Delivery Services, you consent to be bound by the terms, as amended, at the time you use the Delivery Services.",
    "These terms are additional to terms you have entered into in relation to your use of Fusion Kitchen website services. For the purpose of Fusion Kitchen terms, the Fusion Kitchen entity you have contracted with for Fusion Kitchen delivery is Stuart.",

    "Use of Delivery Services",

    "1. Once you have been provided access to the Fusion Kitchen, you may receive orders. Please note that the orders received on your website are based on the information supplied by the relevant customers.",

    "2. Stuart delivery partner will deliver the orders you receive.",

    "3. In the case of Stuart delivery, you will contract with Fusion Kitchen and be charged by Fusion Kitchen for the Delivery Services. Fusion Kitchen will request Stuart to collect items from you and deliver such items to your customers on Fusion Kitchen’s behalf.",

    "4. In other cases, such as a Pickup order, you may deliver items which do not require the use of Delivery Services.",

    "5. Fusion Kitchen Delivery is a Stuart Delivery, Fusion Kitchen and Stuart together will endeavour to ensure that your orders received will be delivered to your customers as reasonably possible. We will give you an estimated range of how long the delivery will take after you receive the order. Unfortunately, the independent factors such as traffic and weather, as well as the actions or inactions yourself may cause delays in the provision of Delivery Services.",

    "6. Fusion Kitchen doesn’t guarantee the Delivery Services as it’s the integration of Stuart for the delivery partnership.",

    "7. You and Fusion Kitchen may terminate these Terms or the Delivery Services if the other party violates the provisions of these Terms. Subject to clause 2.10, you can terminate these Terms by writing to us or by no longer requesting Delivery Services. Fusion Kitchen may suspend all or part of the Delivery Services, and otherwise, operate or discontinue the Delivery Services.",

    "8. If the delivery fails for reasons attributed to the customers, for example, your customers were not available during the delivery, you may charge full price for the items and delivery services.",

    "9. If Stuart cancels the Delivery services for any reason not attributed to your customers, they will be entitled to a refund for any if paid.",

    "10. You may reject your orders received if you can’t deliver them to your customers.",
  ];

  const for_customers = [
    "Thank you for choosing Fusion Kitchen",

    "This Delivery Service Agreement (The “Terms”) sets forth relevant terms and conditions governing the provision of Delivery Services for items ordered via Fusion Kitchen, and your relationship with Fusion Kitchen where you request it to provide Delivery Services as described below. You can contact us by using the Help Section of the Fusion Kitchen page.",

    "In order to request Delivery Services in the UK for the first time, all Fusion Kitchen users must accept these terms and conditions. By requesting Delivery Services, you confirm that you accept these terms. These terms will apply to all subsequent orders you place for Delivery Services.",

    "When accessing or using the Delivery Services, you consent to be bound by the terms, as amended, at the time you use the Delivery Services.",

    "These terms are additional to terms you have entered into in relation to your use of Fusion Kitchen website services. For the purpose of Fusion Kitchen terms, the Fusion Kitchen entity you have contracted with for Fusion Kitchen delivery is Stuart.",

    "Use of Delivery Services",

    "1. Once you have been provided access to the Fusion Kitchen, you may place orders. Please note that the orders you place via our website are based on the information supplied by you.",

    "2. Stuart's delivery partner will deliver the orders you place.",

    "3. Fusion Kitchen will request Stuart to collect items from the takeaway and deliver such items to you on Fusion Kitchen’s behalf.",

    "4. In other cases, such as a Pickup order, you may collect items which do not require the use of Delivery Services.",

    "5. Fusion Kitchen Delivery is a Stuart Delivery, Fusion Kitchen and Stuart together will endeavour to ensure that your orders placed will be delivered to you as reasonably possible. We will give you an estimated range of how long the delivery will take after you place the order. Unfortunately, the independent factors such as traffic and weather, as well as the actions or inactions yourself may cause delays in the provision of Delivery Services.",

    "6. Fusion Kitchen doesn’t guarantee the Delivery Services as it’s the integration of Stuart for the delivery partnership.",

    "7. You and Fusion Kitchen may terminate these Terms or the Delivery Services if the other party violates the provisions of these Terms. Subject to clause 2.10, you can terminate these Terms by writing to us or by no longer requesting Delivery Services. Fusion Kitchen may suspend all or part of the Delivery Services, and otherwise, operate or discontinue the Delivery Services.",

    "8. You may reject the orders placed if you don’t need to proceed before the orders get confirmed by the takeaway.",

    "9. If the delivery fails for reasons attributed to you, for example, you were not available during the delivery, you may be charged full price for the items and delivery services.",

    "10. If Stuart cancels the Delivery services for any reason not attributed to you, they will be entitled to a refund for any if paid.",
  ];

  const clients_customers = [
    "Delivery Requirements",

    "1. The delivery driver undertakes to the customer that it will comply with the minimum standards set out below and that it will also comply with any additional requests that may be made by the user or any other requirements set by the customer from time to time, whether directly through the application or via Fusion Kitchen. The Delivery partners agree to procure that their employees, workers, contractors, agents or representatives will also comply with these standards and requests.",

    "2. If the delivery order requires specific conditions, on the order of the customer in terms of hygiene, temperature or equipment, for example for chilled items, fragile items, etc. or other conditions required to meet applicable legislation, the delivery driver must ensure, prior to its acceptance, that its method of transport and equipment meets these specifications.",

    "3. The delivery driver will ensure that it has the equipment required to meet the customer's needs for delivery capacity and quality as outlined and as updated by Fusion Kitchen from time to time.",

    "4. The delivery driver can use unbranded equipment where the branded equipment is purchased from or supplied by Stuart. The terms of conditions for the purchase of equipment will be presented to the delivery drivers upon request. Fusion Kitchen reserves the right to undertake checks to ensure that delivery drivers have the equipment that they have reported to Fusion Kitchen that they are using. Fusion Kitchen may suspend or terminate the account of any delivery driver that does not have the equipment that they have reported to the Fusion Kitchen.",

    "In addition, the delivery driver shall comply with the following customer requirements :",

    "1. Act with professionalism and carry out the deliveries of orders diligently, demonstrating the highest level of care;",

    "2. Act responsibly with the orders, ie., to ensure they are not damaged, destroyed, tampered with, stolen or lost, and act responsibly in the driving of its method of transport;",

    "3. Do not carry out or be engaged in any conduct prejudicial to the customer, including any discrimination, harassment, threatening behaviour, criminal activity or any fraudulent action (as determined by Fusion Kitchen, acting reasonably, as constituting fraudulent action);",

    "4. Maintain a professional, clean and tidy appearance;",

    "5. Maintain personal hygiene standards appropriate to the serving of food;",

    "6. Make every effort not to disturb the operation of any business at the collection or destination address;",

    "7. Undertake an age-verified delivery policy or other appropriate training in order to be able to undertake deliveries of alcohol products, energy drinks or any other age-restricted items;",

    "8. Comply with age-verified delivery policy requirements, proceed with all necessary checks at pick up and drop off and apply any mandatory requirements imposed by the regulation;",

    "9. Execute deliveries of orders in accordance with the estimated delivery times provided via the application and any requested time limits or deadlines indicated by the customer;",

    "10. Have a good standard of spoken English;",

    "11. Ensure that it has the appropriate method of transport and equipment for the delivery of orders requested by the customer and that these are clean and appropriately maintained in good roadworthy condition; and",

    "12. Comply with any operating standards for that customer that may be communicated to it from time to time. This includes compliance with pick up procedures(for example, checking in when arriving at a restaurant, using appropriate entry points and ensuring that the delivery driver identifies himself), delivery procedures (for example, ensuring that certain deliveries are not re-routed), parking requirements and other requirements regarding premises (such as a requirement not to sit at tables).",

    "13. Once the delivery order is accepted by the delivery driver, the orders should be collected and delivered in a timely manner and without delay. If a delay is experienced in the collection, the delivery driver should contact the customer and Fusion Kitchen in order to clear the particular delivery of orders from the application and allow Fusion Kitchen to reassign an appropriate delivery driver.",

    "14. If a specific process or waiting time is required by a customer, this will be communicated to the delivery driver by Fusion Kitchen from time to time.",
  ];

  const communication = [
    "The delivery driver may need to contact the customer by telephone after acceptance of the delivery orders. The customer must be contactable on the number indicated by it in its account in order to answer the delivery driver’s questions.",

    "The delivery driver may also need to contact the takeaway and/or Fusion Kitchen, if not the customer, by telephone at the time of delivery of orders.",

    "In this respect, the customer who has entered the telephone numbers of Fusion Kitchen and/or the takeaway, so they can be contacted by the delivery driver within the framework of the delivery of orders, represents and warrants that it has obtained their agreement to do so.",

    "The telephone details entered are only kept by Fusion Kitchen for the time of delivery of orders and are encrypted. This means that the delivery driver can contact the customer and/or the takeaway and/or Fusion Kitchen, via the application, without being able to see the telephone numbers.",
  ];

  const confirmation = [
    "Irrespective of the method of transport used or the package size selected by the customer, if the delivery driver accepts the delivery of an order, it undertakes to the customer to give effect to the delivery of orders as contemplated by the GCU.",
  ];

  const acceptance = [
    "Acceptance of the delivery driver of an order via the application binds the delivery driver to undertake the said delivery of orders, pursuant to the provisions of the GCU. Fusion Kitchen cannot require or force a delivery driver to accept a delivery order and the delivery driver makes any such acceptance entirely at its own discretion.",
  ];

  const processes_relative = [
    "The customer enters into the application the collection address, the takeaway from whom the delivery driver must collect the orders, the delivery address and the customer to which the delivery driver must deliver the orders, together with, as a minimum, a telephone number, which may be that of the customer and/or the takeaway and/or Fusion Kitchen, and lastly the order size which relates to the orders or the method of transport (as appropriate).",

    "The customer acknowledges and agrees that this is essential information for the delivery of orders on the basis of which the delivery driver is bound.",

    "The Customer represents and warrants to the Fusion Kitchen and the delivery driver that it shall;",

    "Request the delivery of orders to a named individual;",

    "Have the prior permission of the takeaway and the Fusion Kitchen to communicate to the Fusion Kitchen and the delivery driver the information entered concerning them, which may be a surname, forename, postal address, and telephone number, to enable the delivery of orders;",

    "Specify the details, obvious or otherwise, of the orders when they may have repercussions on the progress of the delivery by the delivery driver, in particular, if they do not correspond to the order size selected by the customer or they may affect the method of transport;",

    "Not request delivery of orders to a customer who is inaccessible or which would require unreasonable efforts by the delivery driver, such as customers who may be incarcerated or whose address is inaccessible by land and/or close to the marked road;",

    "Only use the service and the delivery orders for legal purposes.",

    "Subject to the foregoing, a fixed and final price, as deemed to have been agreed between the customer and the delivery driver shall then be communicated to the customer for the delivery of orders.",

    "An estimate of the time for delivery of orders (including the approach time initially, then collection until delivery secondly) shall also be communicated to the customer. Any timeframes specified shall be indicative only and shall not be binding on the delivery driver (nor on the Fusion Kitchen, which, in accordance with the GCU, is not a party to the contract for the delivery of orders)",
  ];

  const payment = [
    "1. The price of the Delivery Services will be determined based on the radius of the delivery to be made to your customers. All charges are in pounds sterling and include VAT",
    "2 .You shall receive any charges for Delivery Services via Fusion Kitchen.",
    "3 .The price is dependent on geography and order count. For the avoidance of doubt, the price is always inclusive of the delivery fee.",
    "4 .Prices are determined by the delivery of orders and are calculated automatically by the application. The distance to be travelled between the Takeaway Address and Delivery Address.",
  ];

  const general_principles = [
    "Pursuant to the GCU, and as stated elsewhere in the GCU, the delivery of orders is not executed by the Fusion Kitchen but by the Delivery Partners (Stuart) only.",
    "1. Damage of orders",
    "If a customer refuses the delivery of orders due to the alleged destruction of the order or their damage, spoiling, or leakage, then the price of the service will be debited from the customer and it shall be the user’s responsibility to demonstrate to the Fusion Kitchen, that the alleged damage has indeed occurred, in which case a refund of the price of the service may be issued to the customer.",

    "2. Other causes",
    "No suspension nor reimbursement of the price owed by the customer shall be made in any circumstances, including without limitation, the refusal of the Goods by the Recipient, or its refusal to receive them. If the customer refuses to accept the orders for any reason, the Delivery driver shall return the order through delivery of the order and the customer will be billed for such a return, or the customer can instruct the delivery driver to bin the order. For the avoidance of doubt, the delivery driver should not dispose of any orders unless expressly instructed to do so by the customer or the Fusion Kitchen. Any unauthorised disposal will be subject to loss of order. The customer acknowledges and agrees that the delivery driver is not responsible for any non-conformity of the orders or delay in delivery of orders in relation to the estimated time frame indicated and that these do not constitute a valid and admissible reason for refusing to accept the orders.",
    "In the event of a dispute, it shall be the customer’s responsibility to contact the delivery driver to obtain any compensation and to inform the company of any such dispute.",
  ];
  const cancellation = [
    "1. Cancellation by the customer",

    "The customer may cancel the order delivery, without cost, up to two (2) minutes before the delivery confirmation via the Application, provided that the orders have not been collected from the delivery driver.",

    "After this time, the customer may cancel the delivery of the order before the order has been collected by the delivery driver from the takeaway. Should the customer cancel after the initial two (2) minutes have passed, the customer will be charged the cancellation fee. The cancellation fee is such other charges as Fusion Kitchen may determine and communicate to the takeaways on time.",
    "For the avoidance of doubt, Fusion Kitchen shall play no part in the decision by a customer to cancel the delivery of an order but may need to give effect to the cancellation via the application if so requested by the customer.",

    "2. Cancellation by the delivery driver",
    "The delivery driver may cancel the delivery of orders for any reason, whether through the application or by requesting the cancellation from Fusion Kitchen. If so requested, the Fusion Kitchen will give effect to the cancellation via the application on the delivery driver’s behalf. If the delivery driver cancels any delivery of orders for any reason, Fusion Kitchen will reassign an appropriate delivery driver.",

    "If the delivery driver has waited for the collection of orders at the relevant collection address for a period in excess of the waiting time, the delivery driver may request cancellation of the delivery of orders. Should delivery of orders be cancelled following the request of the delivery driver in these circumstances, the customer will be charged the cancellation charges. This provision shall only be applicable once Fusion Kitchen has communicated in writing to the delivery driver the launch to wait at pick up in the delivery driver’s specific region.",

    "For the avoidance of doubt, Fusion Kitchen shall play no part in the decision by the delivery driver to cancel an order delivery.",
  ];
  const Return_orders = [
    "If the delivery driver is unable to contact the customer and /or the takeaway and/or the customer, the delivery driver may, at its discretion, automatically terminate the delivery of orders.",
    "If the delivery driver is unable to give effect to the delivery of orders to the customer and terminates the delivery of orders pursuant, the delivery driver must return the order to the customer or the takeaway, as appropriate. For the avoidance of doubt, the delivery driver should not dispose of any orders unless expressly instructed to do so by the customer or Fusion Kitchen.",
    "In order to give effect to the return, the delivery driver shall make contact with Fusion Kitchen in order to organise the delivery of orders to the collection address (reverse process) so that the delivery driver can return the orders to the takeaway or the customer. The cost of this delivery of the order shall be identical to that of the outward delivery.",
  ];

  return (
    <div>
      <GoToTop />
      <SeoComponent pageUrl="terms-conditions" businessTitle="FusionPOS" />
      <ScrollToTop />
      <ChatIcon />
      <Navbar />
      <div className=" text-center ">
        <h1 className="text-[20px] text-[#333333] font-bold py-10 bg-green-100 pt-24
                       md:pt-36 px-10 md:py-24 md:text-[24px]
                       lg:pt-56  lg:py-32 lg:text-[36px]
                       xl:py-32 xl:text-[50px] xl:pt-56 

                       
                       ">
          Delivery Partnership Terms and Conditions
        </h1>
      </div>
      <div className="mt-5 2xl:max-w-[1250px] xl:max-w-[1140px] md:mx-12 xl:mx-auto mx-5">
        {/* for clients */}
        <div id="accordion-flush" className="">
          <h2 id="accordion-flush-heading-1">
            <button
              onClick={() => toggleAccordion("ForClients")}
              type="button"
              className="flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200 "
              data-accordion-target="#accordion-flush-body-2"
              aria-expanded={openSection === "ForClients"}
              aria-controls="accordion-flush-body-2"
            >
              <span className="text-[#333333] ">
                Delivery Partnership Terms and Conditions - For Clients
              </span>
              <span>
                {openSection === "ForClients" ? (
                  <IoIosArrowUp size={"20px"} />
                ) : (
                  <IoIosArrowDown size={"20px"} />
                )}
              </span>
            </button>
          </h2>
          <div
            ref={accordionRefs.ForClients}
            id="accordion-flush-body-2"
            className={openSection === "ForClients" ? "block" : "hidden"}
            aria-labelledby="accordion-flush-heading-1"
          >
            <div className="py-5 border-b border-gray-200 dark:border-gray-700 duration-1000">
              {for_clients.map((res, index) => (
                <ol className=" mb-5 text-gray-500 text-justify  ">
                  <li key={index} className="">
                    {res}
                  </li>
                </ol>
              ))}
            </div>
          </div>
        </div>

        {/* Delivery Partnership Terms and Conditions - For Customers     */}
        <div id="accordion-flush" className="">
          <h2 id="accordion-flush-heading-1">
            <button
              onClick={() => toggleAccordion("ForCustomers")}
              type="button"
              className="flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200 "
              data-accordion-target="#accordion-flush-body-1"
              aria-expanded={openSection === "ForCustomers"}
              aria-controls="accordion-flush-body-1"
            >
              <span className="text-[#333333] ">
                Delivery Partnership Terms and Conditions - For Customers
              </span>
              <span>
                {openSection === "ForCustomers" ? (
                  <IoIosArrowUp size={"20px"} />
                ) : (
                  <IoIosArrowDown size={"20px"} />
                )}
              </span>
            </button>
          </h2>
          <div
            ref={accordionRefs.ForCustomers}
            id="accordion-flush-body-1"
            className={openSection === "ForCustomers" ? "block" : "hidden"}
            aria-labelledby="accordion-flush-heading-1"
          >
            <div className="py-5 border-b border-gray-200 dark:border-gray-700 duration-1000">
              {for_customers.map((res, index) => (
                <p key={index} className="mb-5 text-gray-500 text-justify">
                  {res}
                </p>
              ))}
            </div>
          </div>
        </div>

        {/* General Terms - Clients & Customers */}
        <div id="accordion-flush" className="">
          <h2 id="accordion-flush-heading-1">
            <button
              onClick={() => toggleAccordion("PurchasingProduct")}
              type="button"
              className="flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200 "
              data-accordion-target="#accordion-flush-body-2"
              aria-expanded={openSection === "PurchasingProduct"}
              aria-controls="accordion-flush-body-2"
            >
              <span className="text-[#333333] ">
                General Terms - Clients & Customers
              </span>
              <span>
                {openSection === "PurchasingProduct" ? (
                  <IoIosArrowUp size={"20px"} />
                ) : (
                  <IoIosArrowDown size={"20px"} />
                )}
              </span>
            </button>
          </h2>
          <div
            ref={accordionRefs.PurchasingProduct}
            id="accordion-flush-body-2"
            className={openSection === "PurchasingProduct" ? "block" : "hidden"}
            aria-labelledby="accordion-flush-heading-1"
          >
            <div
              className="py-5 border-b border-gray-200 dark:border-gray-700
                         text-[#333333] duration-1000 "
            >
              <p className=""></p>

              {clients_customers.map((res, index) => (
                <ol className=" mb-5 text-gray-500 text-justify">
                  <li key={index}>{res}</li>
                </ol>
              ))}
            </div>
          </div>
        </div>

        {/* Communication between the customer, the delivery driver,
            the takeaway and Fusion Kitchen */}
        <div id="accordion-flush" className="">
          <h2 id="accordion-flush-heading-1">
            <button
              onClick={() => toggleAccordion("Communication")}
              type="button"
              className="flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200  dark:text-gray-400"
              data-accordion-target="#accordion-flush-body-2"
              aria-expanded={openSection === "Communication"}
              aria-controls="accordion-flush-body-2"
            >
              <span className="text-[#333333] ">
                Communication between the customer, the delivery driver, the
                takeaway and Fusion Kitchen
              </span>
              <span>
                {openSection === "Communication" ? (
                  <IoIosArrowUp size={"20px"} />
                ) : (
                  <IoIosArrowDown size={"20px"} />
                )}
              </span>
            </button>
          </h2>
          <div
            ref={accordionRefs.Communication}
            id="accordion-flush-body-2"
            className={openSection === "Communication" ? "block" : "hidden"}
            aria-labelledby="accordion-flush-heading-1"
          >
            <div className="py-5 border-b border-gray-200  duration-1000">
              <div className=""></div>
              {communication.map((res, index) => (
                <ol className=" mb-5 text-gray-500 text-justify">
                  <li key={index}>{res}</li>
                </ol>
              ))}
            </div>
          </div>
        </div>

        {/* Confirmation of the delivery orders */}
        <div id="accordion-flush" className="">
          <h2 id="accordion-flush-heading-1">
            <button
              onClick={() => toggleAccordion("Confirmation")}
              type="button"
              className="flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200  dark:text-gray-400"
              data-accordion-target="#accordion-flush-body-2"
              aria-expanded={openSection === "Confirmation"}
              aria-controls="accordion-flush-body-2"
            >
              <span className="text-[#333333] ">
                Confirmation of the delivery orders{" "}
              </span>
              <span>
                {openSection === "Confirmation" ? (
                  <IoIosArrowUp size={"20px"} />
                ) : (
                  <IoIosArrowDown size={"20px"} />
                )}
              </span>
            </button>
          </h2>
          <div
            ref={accordionRefs.Confirmation}
            id="accordion-flush-body-2"
            className={openSection === "Confirmation" ? "block" : "hidden"}
            aria-labelledby="accordion-flush-heading-1"
          >
            <div className="py-5 border-b border-gray-200  duration-1000">
              <div className=""></div>
              {confirmation.map((res, index) => (
                <ol className=" mb-5 text-gray-500 text-justify">
                  <li key={index}>{res}</li>
                </ol>
              ))}
            </div>
          </div>
        </div>

        {/* Acceptance by the delivery driver of the order */}
        <div id="accordion-flush" className="">
          <h2 id="accordion-flush-heading-1">
            <button
              onClick={() => toggleAccordion("Acceptance")}
              type="button"
              className="flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200  dark:text-gray-400"
              data-accordion-target="#accordion-flush-body-2"
              aria-expanded={openSection === "Acceptance"}
              aria-controls="accordion-flush-body-2"
            >
              <span className="text-[#333333] ">
                Acceptance by the delivery driver of the order
              </span>
              <span>
                {openSection === "Acceptance" ? (
                  <IoIosArrowUp size={"20px"} />
                ) : (
                  <IoIosArrowDown size={"20px"} />
                )}
              </span>
            </button>
          </h2>
          <div
            ref={accordionRefs.Acceptance}
            id="accordion-flush-body-2"
            className={openSection === "Acceptance" ? "block" : "hidden"}
            aria-labelledby="accordion-flush-heading-1"
          >
            <div className="py-5 border-b border-gray-200  duration-1000">
              <div className=""></div>
              {acceptance.map((res, index) => (
                <ol className=" mb-5 text-gray-500 text-justify">
                  <li key={index}>{res}</li>
                </ol>
              ))}
            </div>
          </div>
        </div>

        {/* Processes relative to the delivery of orders  */}
        <div id="accordion-flush" className="">
          <h2 id="accordion-flush-heading-1">
            <button
              onClick={() => toggleAccordion("ProcessesRelative")}
              type="button"
              className="flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200  dark:text-gray-400"
              data-accordion-target="#accordion-flush-body-2"
              aria-expanded={openSection === "ProcessesRelative"}
              aria-controls="accordion-flush-body-2"
            >
              <span className="text-[#333333] ">
                Processes relative to the delivery of orders
              </span>
              <span>
                {openSection === "ProcessesRelative" ? (
                  <IoIosArrowUp size={"20px"} />
                ) : (
                  <IoIosArrowDown size={"20px"} />
                )}
              </span>
            </button>
          </h2>
          <div
            ref={accordionRefs.ProcessesRelative}
            id="accordion-flush-body-2"
            className={openSection === "ProcessesRelative" ? "block" : "hidden"}
            aria-labelledby="accordion-flush-heading-1"
          >
            <div className="py-5 border-b border-gray-200  duration-1000">
              <div className="font-semibold">
                {" "}
                Request for delivery of orders by the customer
              </div>
              {processes_relative.map((res, index) => (
                <ol className=" mb-5 text-gray-500 text-justify">
                  <li key={index}>{res}</li>
                </ol>
              ))}
            </div>
          </div>
        </div>

        {/* Payment for the Delivery Services */}
        <div id="accordion-flush" className="">
          <h2 id="accordion-flush-heading-1">
            <button
              onClick={() => toggleAccordion("Payment")}
              type="button"
              className="flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200  dark:text-gray-400"
              data-accordion-target="#accordion-flush-body-2"
              aria-expanded={openSection === "Payment"}
              aria-controls="accordion-flush-body-2"
            >
              <span className="text-[#333333] ">
                Payment for the Delivery Services
              </span>
              <span>
                {openSection === "Payment" ? (
                  <IoIosArrowUp size={"20px"} />
                ) : (
                  <IoIosArrowDown size={"20px"} />
                )}
              </span>
            </button>
          </h2>
          <div
            ref={accordionRefs.Payment}
            id="accordion-flush-body-2"
            className={openSection === "Payment" ? "block" : "hidden"}
            aria-labelledby="accordion-flush-heading-1"
          >
            <div className="py-5 border-b border-gray-200  duration-1000">
              <div className=""> </div>
              {payment.map((res, index) => (
                <ol className=" mb-5 text-gray-500 text-justify">
                  <li key={index}>{res}</li>
                </ol>
              ))}
            </div>
          </div>
        </div>

        {/* General principles */}
        <div id="accordion-flush" className="">
          <h2 id="accordion-flush-heading-1">
            <button
              onClick={() => toggleAccordion("GeneralPrinciples")}
              type="button"
              className="flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200  dark:text-gray-400"
              data-accordion-target="#accordion-flush-body-2"
              aria-expanded={openSection === "GeneralPrinciples"}
              aria-controls="accordion-flush-body-2"
            >
              <span className="text-[#333333] ">General principles</span>
              <span>
                {openSection === "GeneralPrinciples" ? (
                  <IoIosArrowUp size={"20px"} />
                ) : (
                  <IoIosArrowDown size={"20px"} />
                )}
              </span>
            </button>
          </h2>

          <div
            ref={accordionRefs.GeneralPrinciples}
            id="accordion-flush-body-2"
            className={openSection === "GeneralPrinciples" ? "block" : "hidden"}
            aria-labelledby="accordion-flush-heading-1"
          >
            <div className="py-1 border-b border-gray-200  duration-1000">
              <div className="font-bold py-3 text-[#333333]"></div>
              {general_principles.map((res, index) => (
                <ol className=" mb-5 text-gray-500 text-justify">
                  <li key={index}>{res}</li>
                </ol>
              ))}
            </div>
          </div>
        </div>

        {/* Cancellation: */}
        <div id="accordion-flush" className="">
          <h2 id="accordion-flush-heading-1">
            <button
              onClick={() => toggleAccordion("Cancellation")}
              type="button"
              className="flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200  dark:text-gray-400"
              data-accordion-target="#accordion-flush-body-2"
              aria-expanded={openSection === "Cancellation"}
              aria-controls="accordion-flush-body-2"
            >
              <span className="text-[#333333] ">Cancellation</span>
              <span>
                {openSection === "Cancellation" ? (
                  <IoIosArrowUp size={"20px"} />
                ) : (
                  <IoIosArrowDown size={"20px"} />
                )}
              </span>
            </button>
          </h2>
          <div
            ref={accordionRefs.Cancellation}
            id="accordion-flush-body-2"
            className={openSection === "Cancellation" ? "block" : "hidden"}
            aria-labelledby="accordion-flush-heading-1"
          >
            <div className="py-5 border-b border-gray-200  duration-1000">
              <div className="font-bold py-3 text-[#333333]"></div>
              {cancellation.map((res, index) => (
                <ol className=" mb-5 text-gray-500 text-justify">
                  <li key={index}>{res}</li>
                </ol>
              ))}
            </div>
          </div>
        </div>

        {/* Return of orders by the delivery driver */}
        <div id="accordion-flush" className="">
          <h2 id="accordion-flush-heading-1">
            <button
              onClick={() => toggleAccordion("ReturnOrders")}
              type="button"
              className="flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200  dark:text-gray-400"
              data-accordion-target="#accordion-flush-body-2"
              aria-expanded={openSection === "ReturnOrders"}
              aria-controls="accordion-flush-body-2"
            >
              <span className="text-[#333333] ">
                Return of orders by the delivery driver{" "}
              </span>
              <span>
                {openSection === "ReturnOrders" ? (
                  <IoIosArrowUp size={"20px"} />
                ) : (
                  <IoIosArrowDown size={"20px"} />
                )}
              </span>
            </button>
          </h2>
          <div
            ref={accordionRefs.ReturnOrders}
            id="accordion-flush-body-2"
            className={openSection === "ReturnOrders" ? "block" : "hidden"}
            aria-labelledby="accordion-flush-heading-1"
          >
            <div className="py-5 border-b border-gray-200  duration-1000">
              <div className="font-bold py-3 text-[#333333]"></div>
              {Return_orders.map((res, index) => (
                <ol className=" mb-5 text-gray-500 text-justify">
                  <li key={index}>{res}</li>
                </ol>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DeliveryPartnershipTC;
